<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "TradingBook",
        components: {
        },
        methods: {

        },
    }
</script>

<style scoped>

</style>
